import React from 'react';

interface InputProps {
  name: string;
  label?: string;
  id?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  className?: string;
  placeholder?: string;
  type?: string;
  value?: any;
  min?: string;
  max?: string;
  maxLength?: number;
  autoComplete?: string;
  onBlur?: (_: any, name: string) => void;
  onKeyDown?: (_: any) => void;
  onChange?: (_: any, name: string) => void;
  readOnly?: boolean;
}

const Input: React.FC<InputProps> = ({
  label,
  id,
  disabled,
  name,
  required,
  error,
  errorMessage,
  className,
  placeholder,
  type,
  value,
  min,
  max,
  maxLength,
  autoComplete,
  onBlur,
  onKeyDown,
  onChange,
  readOnly,
}) => {
  return (
    <>
      <input
        id={id}
        name={name}
        className={`form-control ${error ? 'is-invalid' : ''} ${className || ''}`}
        placeholder={placeholder}
        type={type}
        value={value}
        min={min}
        max={max}
        maxLength={maxLength}
        autoComplete={autoComplete || 'off'}
        onBlur={(e) => onBlur && onBlur(e, name)}
        onKeyDown={onKeyDown}
        onChange={(e) => onChange && onChange(e, name)}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
      />
      {label && (
        <label htmlFor={id}>
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      {error && (
        <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback">
          <div data-field={id} data-validator="notEmpty">
            {errorMessage}
          </div>
        </div>
      )}
    </>
  );
};

export default Input;
